<template>
  <!--Card-->
  <div class="card">

    <!--Card image-->
    <div>
      <slot class="card-img-top" name="image"></slot>
    </div>
    <!--/.Card image-->

    <!--Card content-->
    <div class="card-block">
      <!--Title-->
      <h4 class="card-title" v-if="showTitle"><slot name="title"></slot></h4>
      <!--Text-->
      <p class="card-text"><slot name="content"></slot></p>
    </div>
    <!--/.Card content-->

  </div>
  <!--/.Card-->
</template>


<script>
import { mapState } from 'vuex';

export default {
  name: 'Card',
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      language: state => state.language,
    }),
    showTitle() {
      if (typeof this.$slots.title !== 'undefined') {
        return true;
      }
      return false;
    },
  },
  watch: {

  },
};
</script>

<style lang="scss" scoped>
.card-img-top {
  max-height: 190px
}
img {
  box-shadow: none;
}
.card-title img, .card-text img{
  display: inline;
}


</style>



// WEBPACK FOOTER //
// Card.vue?f7cb6b68